import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { LogOut, User as UserIcon, Bell } from "lucide-react"; 
import logo from "../../assets/icons/logov2.png";

export default function Navbar() {
  const { user, logout } = useContext(AuthContext);

  return (
    <header className="sticky top-0 z-50 flex items-center justify-between bg-white/80 backdrop-blur-md border-b border-slate-200 px-8 py-4">
      
      {/* SECCIÓN IZQUIERDA: Identidad */}
      <div className="flex items-center gap-4 group cursor-pointer">
        <div className="relative">
          <div className="absolute inset-0 bg-blue-500 rounded-lg blur opacity-20 group-hover:opacity-40 transition-opacity"></div>
          <img 
            src={logo} 
            alt="Prodsync" 
            className="relative w-9 h-9 object-contain" 
          />
        </div>
        <div className="flex flex-col">
          <h1 className="text-lg font-black text-slate-900 leading-none tracking-tight">
            PRODSYNC
          </h1>
          <span className="text-[10px] font-bold text-blue-600 tracking-[0.2em] uppercase">
            Control Center
          </span>
        </div>
      </div>

      {/* SECCIÓN DERECHA: Usuario y Acciones */}
      <div className="flex items-center gap-6">
        
        {/* Notificaciones (Placeholder visual) */}
        <button className="relative p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-all">
          <Bell className="w-5 h-5" />
          <span className="absolute top-2 right-2 w-2 h-2 bg-blue-500 rounded-full border-2 border-white"></span>
        </button>

        <div className="h-8 w-[1px] bg-slate-200 mx-2 hidden md:block"></div>

        {/* Perfil de Usuario */}
        <div className="flex items-center gap-4">
          <div className="hidden md:flex flex-col items-end">
            <p className="text-sm font-bold text-slate-900 leading-none">
              {user?.fullName || "Administrador"}
            </p>
            <p className="text-[11px] text-slate-500 mt-1">
              {user?.email || user?.dni || "Sesión activa"}
            </p>
          </div>
          
          <div className="w-10 h-10 bg-slate-100 border border-slate-200 rounded-xl flex items-center justify-center text-slate-400">
            <UserIcon className="w-5 h-5" />
          </div>

          {/* Botón Salir Estilizado */}
          <button
            onClick={logout}
            className="flex items-center gap-2 bg-slate-900 hover:bg-red-600 text-white px-4 py-2 rounded-xl text-sm font-bold transition-all shadow-sm hover:shadow-red-500/20 active:scale-95"
          >
            <LogOut className="w-4 h-4" />
            <span className="hidden sm:inline">Cerrar Sesión</span>
          </button>
        </div>
      </div>
    </header>
  );
}